import { cn } from '@sourcepilot/ui/framework/data/utils'

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  centered?: 'horizontal' | 'all' | undefined
}

export function Spinner({ size = 'md', className, centered = undefined }: SpinnerProps) {
  return (
    <div className={cn(
      centered === 'all'
        ? "w-full h-full min-h-[20rem] flex items-center justify-center"
        : centered === 'horizontal' && "w-full flex items-center justify-center",
      className
    )}>
      <div 
        className={cn(
          "animate-spin rounded-full",
          {
            'w-4 h-4 border-[2px]': size === 'sm',
            'w-8 h-8 border-[3px]': size === 'md',
            'w-12 h-12 border-[4px]': size === 'lg'
          },
          "border-slate-200 border-t-slate-800"
        )} 
      />
    </div>
  )
} 